import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@assets/img/user.png'


const _hoisted_1 = { class: "headerUser" }
const _hoisted_2 = { class: "header-user-box" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "headerUser-img" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_4 = { class: "headerUser-text" }
const _hoisted_5 = { class: "boxMenu" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "box-menu-item pointer" }, "Смена пароля", -1)
const _hoisted_7 = { class: "boxMenuSidebar" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "box-menu-item pointer" }, "Смена пароля", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_box_menu = _resolveComponent("ui-box-menu")!
  const _component_ui_box_menu_sidebar = _resolveComponent("ui-box-menu-sidebar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: "userName",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.changeProfile && _ctx.changeProfile(...args))),
          title: "Войти в профиль"
        }, _toDisplayString(_ctx.userName), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_ctx.isShow)
        ? (_openBlock(), _createBlock(_component_ui_box_menu, { key: 0 }, {
            default: _withCtx(() => [
              _hoisted_6,
              _createElementVNode("div", {
                class: "box-menu-item pointer",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goToHome && _ctx.goToHome(...args)))
              }, "Выход")
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_ui_box_menu_sidebar, { show: _ctx.isShow }, {
        default: _withCtx(() => [
          _hoisted_8,
          _createElementVNode("div", {
            class: "box-menu-item pointer",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goToHome && _ctx.goToHome(...args)))
          }, "Выход")
        ]),
        _: 1
      }, 8, ["show"])
    ])
  ]))
}